const sceneImage = "/images/scene-04.png";

function Scene04({ onNext }) {
  return (
    <>
      {/* Background */}
      <img
        src={sceneImage}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Bottom Content */}
      <div className="absolute inset-x-1 bottom-0 z-10 pb-[calc(1.25rem+env(safe-area-inset-bottom))] text-center">
        <button
          onClick={onNext}
          className="rounded-full border-2 border-[#9a5b08] bg-[#ffd447] px-5 py-2.5 font-playful text-sm font-bold text-[#3d2b1f] shadow-[0_4px_0_#9a5b08] transition-all duration-100 hover:bg-[#ffe071] active:translate-y-[3px] active:shadow-[0_1px_0_#9a5b08]"
        >
          LIHAT HADIAHMU
        </button>
      </div>
    </>
  );
}

export default Scene04;
